import { useState } from "react";

import api, { api_without_cancellation } from "../../../api/api";
import { useDocumentModal } from "../../common/CustomModal/CustomModalContext";
import { useUpdateTrigger } from "../../CostDashboard/TriggerUpdateContext";
import esignImg from "../../../assets/esign_icon.svg";
import deleteImg from "../../../assets/delete.svg";
import printImg from "../../../assets/print.svg";
import downloadImg from "../../../assets/download.svg";
import inboxImg from "../../../assets/inbox.svg";

import SendDocViaEmailModal from "./SendDocViaEmailModal";
import ESignLaunchModal from "./ESignLaunchModal";

const apiEndpoint = "api/delete-doc-api/";

// async function fetchDocument(docId, action = "") {
//   try {
//     const response = await api.post(apiEndpoint, {
//       doc_id: docId,
//       check: action,
//     });
//     return response.data.data;
//   } catch (error) {
//     console.error("API Error:", error.response?.data || error.message);
//     throw error;
//   }
// }

function decodeData(data) {
  return new Uint8Array(
    atob(data)
      .split("")
      .map((char) => char.charCodeAt(0))
  );
}

function createBlob(data, type = "application/pdf") {
  const bytes = decodeData(data);
  return new Blob([bytes], { type });
}

// function useDocumentActions() {
//   const handleAction = async (docId, action = "") => {
//     try {
//       const data = await fetchDocument(docId, action);
//       const blob = createBlob(data);
//       if (action === "Delete") {
//         const url = URL.createObjectURL(blob);
//         return { success: true, url };
//       } else {
//         return { success: true, blob };
//       }
//     } catch (error) {
//       return { success: false, error };
//     }
//   };

//   return { handleAction };
// }

function BottomContentSideBar({
  docId,
  clientId,
  caseId,
  setDeleteConfirmModal,
  refetchDocumentData,
  height,
  isDisabled,
}) {
  const { toggleTriggerUpdate } = useUpdateTrigger();
  const { hideDocumentModal, toggle } = useDocumentModal();
  const [error, setError] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showESignConfirmation, setShowESignConfirmation] = useState(false);
  // const [showESignModal, setShowESignModal] = useState(false); // New state for E-Sign modal
  const [email, setEmail] = useState("");
  // const [modalContent, setModalContent] = useState(""); // State for holding E-Sign content
  const handlePrint = async (docId) => {
    try {
      // Fetch the document data via API
      const response = await api.post("/api/delete-doc-api/", {
        doc_id: docId,
        check: "",
      });

      // Extract the data and convert it to a Blob
      const data = response.data.data;
      const bytes = new Uint8Array(
        atob(data)
          .split("")
          .map((char) => char.charCodeAt(0))
      );
      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      // Create an invisible iframe and append it to the DOM
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
    } catch (error) {
      console.error("Failed to print document:", error.response?.data || error.message);
      setError("Failed to print document. Please try again.");
    }
  };

  const handleDownload = async (docId) => {
    try {
      const response = await api.post(apiEndpoint, {
        doc_id: docId,
        check: "",
      });
      const data = response.data.data;
      const blob = createBlob(data);
      const fileURL = URL.createObjectURL(blob);
      const filename = response.data.filename || "file.pdf";

      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Download error:", error.response?.data || error.message);
    }
  };

  const handleDelete = async (docId) => {
    try {
      // Go straight to the delete payload
      const response = await api_without_cancellation.post(apiEndpoint, {
        doc_id: docId,
        check: "Delete", // Do it all in one go
      });

      const data = response.data.data;
      const filename = response.data.filename || "file.pdf";

      // Handle the file download
      const blob = createBlob(data);
      const fileURL = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileURL);

      // Update UI State
      setDeleteConfirmModal(true);
      if (typeof refetchDocumentData === "function") {
        await refetchDocumentData();
      }
      toggle();
      hideDocumentModal();
      toggleTriggerUpdate();
    } catch (error) {
      console.error("Delete error:", error.response?.data || error.message);
    }
  };

  // const handleDeleteComplete = () => {};

  const handleEmail = async (docId, email) => {
    try {
      await api_without_cancellation.post("/api/email-doc/", { doc_id: docId, email });
      // alert("Document emailed successfully!");
      setShowEmailModal(false);
      setEmail("");
    } catch (error) {
      console.error("Email error:", error.response?.data || error.message);
    }
  };

  const handleRemove = async (docId) => {
    try {
      await api.put("/api/remove-doc/", { doc_id: docId });
      toggleTriggerUpdate();
      toggle();
    } catch (error) {
      setError(error.response?.data?.message || "An unexpected error occurred");
    }
  };

  const handleESign = () => {
    setShowESignConfirmation(true);
  };

  const openESignPage = () => {
    const esignUrl = `/esign/${clientId}/${caseId}/${docId}`;
    window.open(esignUrl, "_blank", "noopener,noreferrer");
    setShowESignConfirmation(false);
  };

  return (
    <>
      <div className="bottom-content side-bar-padding">
        <div className="m-b-5 six-buttons m-l-0 m-r-0">
          <button
            className="btn btn-primary col height-25 d-flex p-0 align-items-center justify-content-center"
            style={{
              fontWeight: "600",
              fontSize: "14px",
              gap: "5px",
              width: height < 745 ? "31px" : "",
            }}
            onClick={() => handlePrint(docId)}
          >
            <img
              className="ic ic-15 d-flex align-items-center justify-content-center"
              style={{
                flexShrink: "0",
              }}
              src={printImg}
            />
            {height > 745 && "Print"}
          </button>
          <button
            className="btn btn-primary download-btn col height-25 p-0 d-flex align-items-center justify-content-center"
            onClick={() => handleDownload(docId)}
            style={{
              fontWeight: "600",
              fontSize: "14px",
              gap: "5px",
              width: height < 745 ? "31px" : "",
            }}
          >
            <img
              className="ic ic-15 d-flex align-items-center  justify-content-center"
              style={{
                flexShrink: "0",
              }}
              src={downloadImg}
            />
            {height > 745 && "Download"}
          </button>
          <button
            className="btn btn-primary col height-25 p-0 d-flex align-items-center justify-content-center"
            onClick={() => setShowEmailModal(true)}
            style={{
              fontWeight: "600",
              fontSize: "14px",
              gap: "5px",
              width: height < 745 ? "31px" : "",
            }}
          >
            <i
              className="ic ic-15 ic-email-3d d-flex align-items-center justify-content-center"
              style={{
                flexShrink: "0",
              }}
            />
            {height > 745 && "Email"}
          </button>
          <button
            type="button"
            className="btn btn-secondary col height-25 d-flex p-0 align-items-center justify-content-center"
            onClick={() => handleRemove(docId)}
            style={{
              fontWeight: "600",
              fontSize: "14px",
              gap: "5px",
              width: height < 745 ? "31px" : "",
            }}
          >
            <img
              className="ic ic-15 d-flex align-items-center justify-content-center"
              style={{
                flexShrink: "0",
              }}
              src={inboxImg}
            />
            {height > 745 && "Inbox"}
          </button>
          <button
            className="btn btn-primary height-25 p-0 d-flex align-items-center justify-content-center flex-g"
            onClick={() => handleESign(docId)}
            // disabled={true}
            style={{
              fontWeight: "600",
              fontSize: "14px",
              gap: "5px",
              width: height < 745 ? "31px" : "",
            }}
            disabled={isDisabled}
          >
            <img
              className="ic ic-15 d-flex align-items-center justify-content-center"
              style={{
                flexShrink: "0",
              }}
              src={esignImg}
            />
            {height > 745 && "E-Sign"}
          </button>
          <button
            type="button"
            onClick={() => handleDelete(docId)}
            className="btn btn-secondary height-25 p-0 d-flex align-items-center justify-content-center flex-g"
            style={{
              fontWeight: "600",
              fontSize: "14px",
              gap: "5px",
              width: height < 745 ? "32px" : "",
            }}
          >
            <img
              className="ic ic-15 d-flex align-items-center justify-content-center"
              style={{
                flexShrink: "0",
              }}
              src={deleteImg}
            />
            {height > 745 && "Delete"}
          </button>
        </div>
        {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}

        {/* Email Modal */}
        {showEmailModal && (
          <SendDocViaEmailModal
            isOpen={showEmailModal}
            setEmail={setEmail}
            email={email}
            docId={docId}
            handleClose={() => {
              setEmail("");
              setShowEmailModal(false);
            }}
            handleEmail={handleEmail}
          />
        )}
        {showESignConfirmation && (
          <ESignLaunchModal
            show={showESignConfirmation}
            onCancel={() => setShowESignConfirmation(false)}
            onConfirm={openESignPage}
          />
        )}
      </div>
    </>
  );
}

export default BottomContentSideBar;
